import { makeStyles } from '@mui/styles';

const usePickerStyles = makeStyles({
  paperBase: {
    backgroundColor: 'transparent',
    boxShadow: 'none',
    width: '100%',
  },
  paperMobile: {
    border: 'none',
    boxShadow: 'none',
    width: 'calc(100vw - 32px)',
    maxWidth: 343,
  },
  pickerRoot: {
    width: '100%',
    maxWidth: 343,
    borderRadius: '16px',
    margin: '0 auto',
    '& .MuiDateCalendar-root, & .MuiDateCalendar-root > div': {
      backgroundColor: '#20243B !important',
      width: '100%',
    },
    '& .MuiPickersLayout-root': {
      borderTopRightRadius: '16px',
      borderTopLeftRadius: '16px',
      backgroundColor: 'transparent',
      display: 'flex',
      flexDirection: 'column',
    },
    '& .MuiPickersLayout-contentWrapper': {
      display: 'flex',
      flexDirection: 'column',
    },
    '& .MuiDateCalendar-root': {
      maxHeight: '514px',
      overflowY: 'auto',
      color: '#FFFFFF',
    },
    '& .MuiDayCalendar-weekContainer': {
      height: '40px',
      justifyContent: 'space-between',
    },
    '& .MuiPickersCalendarHeader-root p': {
      color: '#FFFFFF !important',
    },
    '& .MuiPickersCalendarHeader-root': {
      backgroundColor: '#20243B',
      color: '#FFFFFF',
      padding: 0,
    },
    '& .MuiPickersCalendarHeader-labelContainer': {
      color: '#FFFFFF !important',
      fontSize: 16,
    },
    '& .MuiPickersFadeTransitionGroup-root': {
      display: 'flex',
      justifyContent: 'center',
    },
    '& .MuiSvgIcon-root': {
      color: '#FFFFFF',
    },
    '& .MuiPickersArrowSwitcher-button': {
      backgroundColor: '#20243B !important',
    },
    '& .MuiDayCalendar-weekDayLabel': {
      color: '#76767E !important',
      fontSize: 12,
      width: '40px',
      height: '40px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: 0,
    },
    '& .MuiIconButton-root.Mui-disabled': {
      visibility: 'hidden',
    },
    '& .MuiPickersMonth-monthButton.Mui-disabled': {
      visibility: 'hidden',
    },
    '& .MuiPickersDay-root': {
      color: '#FFFFFF',
      fontSize: 14,
    },
    '& .MuiDayCalendar-header': {
      display: 'flex !important',
      justifyContent: 'space-between',
      color: '#FFFFFF',
      paddingLeft: '0px',
      paddingRight: '0px',
      margin: '0px',
    },
    '& .MuiDayCalendar-weekContainer .MuiPickersDay-root': {
      margin: 0,
    },
    '& .MuiPickersDay-root.Mui-selected': {
      background: '#3BB0FF',
      color: '#20243B',
      borderRadius: 8,
    },
    '& .MuiPickersDay-root.Mui-disabled': {
      color: '#A0A3B9',
    },
    '& .MuiDialogActions-root': {
      display: 'none',
    },
    '& .MuiPickersLayout-actionBar': {
      display: 'none',
    },
    '& .MuiPickersToolbar-root': {
      backgroundColor: '#20243B',
      padding: '0px 0px 12px',
      color: '#FFFFFF',
    },
    '& .MuiPickersLayout-toolbar': {
      backgroundColor: '#20243B',
    },
    '& .MuiPickersToolbar-root .MuiTypography-overline': {
      color: '#FFFFFF !important',
      fontSize: '12px',
      display: 'block !important',
    },
    '& .MuiDatePickerToolbar-title': {
      fontSize: '32px !important',
      fontWeight: 400,
      color: '#FFFFFF !important',
      lineHeight: 1.2,
      margin: 0,
      display: 'block !important',
      whiteSpace: 'nowrap',
    },
    '& .MuiPickersToolbar-penIconButton': {
      display: 'none',
    },
    '& .MuiTypography-h4': {
      fontSize: '20px',
      fontWeight: 400,
      color: '#FFFFFF !important',
      marginTop: '8px',
      display: 'block !important',
    },
    '& .MuiPickersToolbar-root button': {
      color: '#FFFFFF !important',
    },
    '& .MuiPickersToolbar-root .MuiButtonBase-root': {
      display: 'flex !important',
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
    '& .MuiPickersToolbar-content': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
    '& .MuiYearCalendar-root': {
      display: 'grid !important',
      gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
      gridColumnGap: '8px',
      gridRowGap: '8px',
      padding: '8px 12px',
      backgroundColor: '#20243B',
      maxHeight: '280px',
      overflowY: 'auto',
    },
    '& .MuiYearCalendar-root button, & .MuiPickersYear-yearButton': {
      justifySelf: 'center',
      width: '100%',
    },
    '& .MuiPickersYear-yearButton.Mui-selected, & .MuiPickersMonth-monthButton.Mui-selected': {
      background: '#3BB0FF',
      color: '#20243B !important',
      fontSize: '16px',
      margin: 0,
      borderRadius: 8,
    },
    '& .MuiMonthCalendar-root': {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
      gridColumnGap: 8,
      gridRowGap: 20,
      backgroundColor: '#20243B',
      maxHeight: '280px',
      padding: '8px 12px',
      overflowY: 'auto',
    },
    '& .MuiPickersMonth-monthButton': {
      height: '40px',
    },
    '& .MuiTypography-subtitle1': {
      fontSize: '16px',
      color: '#FFFFFF',
    },
    '& .MuiPickersDay-root.MuiPickersDay-today': {
      border: '1px solid #3BB0FF',
    },
    '@media (max-width: 768px)': {
      maxWidth: '100%',
    },
  },
});

export { usePickerStyles };
